export * from "./capi.js";
export const Vue2 = void 0;
export const isVue2 = false;
export const isVue3 = true;
